import React from 'react';
import { Box } from '@mui/material';

import { HandsontableCommon } from '../common/handsontable-common';

import { ConfirmSectionTitle } from './confirm-title';

import type { PlanTableData, RowsWithErrors } from '../common/handsontable.types';
import type { SearchOption } from '@/types/search';

interface CreateSectionProps {
  tableData: PlanTableData;
  plantOptions: SearchOption[];
  witnessCompanyOptions: SearchOption[];
  rowsWithErrors?: RowsWithErrors;
  setRowsWithErrors?: (rowsWithErrors: RowsWithErrors) => void;
  onDataChange?: (data: PlanTableData) => void;
}

export const CreateSection: React.FC<CreateSectionProps> = ({
  tableData,
  plantOptions,
  witnessCompanyOptions,
  rowsWithErrors = [],
  setRowsWithErrors,
  onDataChange,
}) => {
  if (tableData.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      <ConfirmSectionTitle title='新規登録' count={tableData.length} />
      <HandsontableCommon
        tableData={tableData}
        plantOptions={plantOptions}
        witnessCompanyOptions={witnessCompanyOptions}
        rowsWithErrors={rowsWithErrors}
        setRowsWithErrors={setRowsWithErrors}
        onDataChange={onDataChange}
        className='handsontable-confirm-create'
      />
    </Box>
  );
};
